import React from 'react'
import PropTypes from 'prop-types'

import { IMaskInput } from 'react-imask'

import styles from './../style/WorkClean.module.scss'
import form_styles from './../style/Form.module.scss'

import { Container, Image, Form, Modal, Button } from 'react-bootstrap'

import WhiteBlockTitle from './WhiteBlockTitle'
import GreenButton from './GreenButton'

import axios from 'axios'

class WorkClean extends React.Component {
  
  constructor(props) {
    super(props)

    this.state = {
      name: ``,
      phone: ``,
      show_msg: false,
      modal_body: ``,
      isSending: false
    }
  }

  changeName( name ) {
    this.setState({
      name: name
    })
  }

  changePhone( phone ) {
    this.setState({
      phone: phone
    })
  }

  handleShow_msg( text ) {
    this.setState({
      show_msg: true,
      modal_body: text
    })
  }
  
  handleClose_msg() {
    this.setState({
      show_msg: false
    })
  }

  sendForm = ( e ) => {
    e.preventDefault()

    const { name, phone, isSending } = this.state

    // Если уже идет отправка, ничего не делаем
    if (isSending) return;

    const main = this,
    baseURL = window.location.protocol + "//" + window.location.hostname
    
    // Устанавливаем состояние отправки
    this.setState({ isSending: true })
    
    axios.post(`${baseURL}`, {
      'content_type': 'application/json',
      'action': 'feedback_form',
      'form': 'Этапы работы - заявка',
      'name': name,
      'phone': phone,
      'json': JSON.stringify({})
    }, {
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Request-Source': 'Node.js'
      }
    }).then( ( response ) => {
      if( response.data.result ) {
        main.handleShow_msg( `Сообщение отправлено, наш менеджер свяжется с вами в ближайшее время.` )
        // Очищаем форму после успешной отправки
        this.setState({
          name: ``,
          phone: ``
        })
      } else {
        main.handleShow_msg( `Заполните поля формы` )
      }
    }).catch(error => {
      // Показываем сообщение об ошибке
      main.handleShow_msg( `Произошла ошибка при отправке формы. Пожалуйста, попробуйте еще раз.` )
      console.error('Error sending form:', error)
    }).finally(() => {
      // В любом случае снимаем состояние отправки
      this.setState({ isSending: false })
    })
  }

  formatSlideNumber = (index) => {
    // Добавляем ведущий ноль для чисел меньше 10
    return `[${index < 9 ? '0' + (index + 1) : index + 1}]`
  }

  render() {

    const { data, assets_path } = this.props
    const { show_msg, modal_body, isSending, name, phone } = this.state

    return (
      <section className={styles.section}>
        <Container>
          <WhiteBlockTitle
            title={data?.title || ``}
            text={data?.rtext || ``}
          />

          <div className={styles.fline}>
            {data?.list.map( ( elm, k ) => {
              if( ( k + 1 ) != data.list.length ) return (
                <div className={styles.elm} key={k}>
                  <div className={styles.elm_fline}>
                    <div className={styles.elm_fline_icon}>
                      <div><Image src={elm?.icon} /></div>
                    </div>
                    <div className={styles.elm_fline_sep} />
                    <div className={styles.elm_fline_key}>{this.formatSlideNumber(k)}</div>
                  </div>
                  <div className={styles.elm_text}>{elm?.text}</div>
                  {elm?.email != '' &&
                    <div className={styles.elm_email}>
                      <div>{elm?.email}</div>
                      <Image src={`/${assets_path}/images/smsd.svg`} width={24} height={24} />
                    </div>
                  }
                  {k == 0 &&
                  <>
                  <div className={styles.buttons}>
                    <Button className={styles.btn} href={`https://wa.me/+79290532993`} target='_blank' rel='nofollow' variant="primary-outline">
                      <div className={styles.icon}>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          aria-label="WhatsApp"
                          viewBox="0 0 512 512"
                        >
                          <rect width={512} height={512} fill="#25d366" rx="15%" />
                          <path
                            fill="#25d366"
                            stroke="#fff"
                            strokeWidth={26}
                            d="m123 393 14-65a138 138 0 1 1 50 47z"
                          />
                          <path
                            fill="#fff"
                            d="M308 273c-3-2-6-3-9 1l-12 16c-3 2-5 3-9 1-15-8-36-17-54-47-1-4 1-6 3-8l9-14c2-2 1-4 0-6l-12-29c-3-8-6-7-9-7h-8c-2 0-6 1-10 5-22 22-13 53 3 73 3 4 23 40 66 59 32 14 39 12 48 10 11-1 22-10 27-19 1-3 6-16 2-18"
                          />
                        </svg>
                      </div>
                      <div className={styles.name}>Написать в WhatsApp</div>
                    </Button>
                    <Button className={styles.btn} href={`https://t.me/+79290532993`} target='_blank' rel='nofollow' variant="primary-outline">
                      <div className={styles.icon}>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          aria-label="Telegram"
                          viewBox="0 0 512 512"
                        >
                          <rect width={512} height={512} fill="#37aee2" rx="15%" />
                          <path fill="#c8daea" d="M199 404c-11 0-10-4-13-14l-32-105 245-144" />
                          <path fill="#a9c9dd" d="M199 404c7 0 11-4 16-8l45-43-56-34" />
                          <path
                            fill="#f6fbfe"
                            d="m204 319 135 99c14 9 26 4 30-14l55-258c5-22-9-32-24-25L79 245c-21 8-21 21-4 26l83 26 190-121c9-5 17-3 11 4"
                          />
                        </svg>
                      </div>
                      <div className={styles.name}>Написать в Telegram</div>
                    </Button>
                  </div>
                  </>
                  }
                </div>
              )
            } )}
          </div>
          <div className={styles.fline}>
            {data?.list.map( ( elm, k ) => {
              if( ( k + 1 ) == data.list.length ) return (
                <div className={styles.elm_b} key={k}>
                  <div className={styles.elm_fline}>
                    <div className={styles.elm_fline_icon}>
                      <div><Image src={elm?.icon} /></div>
                    </div>
                    <div className={styles.elm_fline_sep} />
                    <div className={styles.elm_fline_key}>{this.formatSlideNumber(k)}</div>
                  </div>
                  <div className={styles.elm_text}>{elm?.text}</div>
                  {elm?.email != '' &&
                    <div className={styles.elm_email}>
                      <div>{elm?.email}</div>
                      <Image src={`/${assets_path}/images/smsd.svg`} width={24} height={24} />
                    </div>
                  }
                </div>
              )
            } )}
            <div className={styles.elm_form}>
              <div className={styles.elm_fline}>
                <div className={styles.elm_fline_icon}>
                  <div><Image src={`/${assets_path}/images/workclean/5.svg`} /></div>
                </div>
                <div className={styles.elm_fline_text}>Вы радуетесь новыми экологичными евроокнами</div>
                <div className={styles.elm_fline_sep} />
                <div className={styles.elm_fline_key}>{this.formatSlideNumber( data.list.length )}</div>
              </div>
              <Form onSubmit={( e ) => this.sendForm( e )}>
                <div className={styles.form_mob}>
                  <div className={`${form_styles.form_input_block_d}`}>
                    <Image src={`/${assets_path}/images/userd.svg`} width={14} height={14} alt="имя" />
                    <Form.Control
                      className={form_styles.form_input}
                      name="name"
                      required
                      value={name}
                      onChange={( e ) => this.changeName( e.target.value )}
                      type="text"
                      placeholder="Ваше имя"
                    />
                  </div>
                  <div className={`${form_styles.form_input_block_d}`}>
                    <Image src={`/${assets_path}/images/call-callingd.svg`} width={14} height={14} alt="тел." />
                    <Form.Control
                      className={form_styles.form_input}
                      name="phone"
                      required
                      value={phone}
                      onChange={( e ) => this.changePhone( e.target.value )}
                      as={IMaskInput}
                      mask="+{7} (000) 000-00-00"
                      lazy={true}
                      type="text"
                      placeholder="+7 (___) ___-__-__"
                    />
                  </div>
                </div>
                <div className={styles.form}>
                  <div className={`${form_styles.form_input_block_d} ${styles.form_input}`}>
                    <Image src={`/${assets_path}/images/userd.svg`} width={14} height={14} alt="имя" />
                    <Form.Control
                      className={form_styles.form_input}
                      name="name"
                      required
                      value={name}
                      onChange={( e ) => this.changeName( e.target.value )}
                      type="text"
                      placeholder="Ваше имя"
                    />
                  </div>
                  <div className={`${form_styles.form_input_block_d} ${styles.form_input}`}>
                    <Image src={`/${assets_path}/images/call-callingd.svg`} width={14} height={14} alt="тел." />
                    <Form.Control
                      className={form_styles.form_input}
                      name="phone"
                      required
                      value={phone}
                      onChange={( e ) => this.changePhone( e.target.value )}
                      as={IMaskInput}
                      mask="+{7} (000) 000-00-00"
                      lazy={true}
                      type="text"
                      placeholder="+7 (___) ___-__-__"
                    />
                  </div>
                  <GreenButton
                    text={isSending ? 'Отправляется...' : `Оставить заявку`}
                    width={141}
                    action={() => {  }}
                    submit={true}
                    disabled={isSending}
                  />
                  <div className={form_styles.form_pconf_d + ` ms-2 mt-0`}>
                    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <rect width="17" height="17" rx="8.5" fill="white"/>
                      <rect x="4" y="4" width="9" height="9" rx="4.5" fill="#00C775"/>
                    </svg>
                    <div>Нажимая на кнопку, вы соглашаетесь<br />с <a href="/privacy">политикой конфиденциальности</a></div>
                  </div>
                </div>
              </Form>
            </div>
          </div>
        </Container>
        <Modal centered show={show_msg} onHide={() => this.handleClose_msg()}>
          <Modal.Header closeButton>
            <Modal.Title>Сообщение</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className='modal-text mt-2'>{modal_body}</div>
          </Modal.Body>
        </Modal>
      </section>
    )
  }
}

WorkClean.propTypes = {
  data: PropTypes.object,
  assets_path: PropTypes.string
}

WorkClean.defaultProps = {
  data: {},
  assets_path: ``
}

export default WorkClean